import { useEffect, useState } from 'react';
import {
    PanelBody,
    Spinner,
    Card,
    CardBody,
    CardMedia,
    CardHeader,
    Button,
} from '@wordpress/components';
import { fetchData, saveData } from './api';

const MorePluginTab = ({ openPopup, setActiveTab }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData(gmwcp_wp_ajax.moreplugin, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching plugin data:', error);
            });
    }, []);

    return (
        <PanelBody title="More Plugins">
            {loading ? (
                <Spinner />
            ) : (
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                    gap: '20px', 
                    marginTop: '20px' 
                }}>
                    {data.map((plugin, index) => (
                        <Card key={index}>
                            {plugin.image && (
                                <CardMedia>
                                    <img 
                                        src={plugin.image} 
                                        alt={plugin.name} 
                                        style={{ 
                                            width: '100%', 
                                            height: '150px', 
                                            objectFit: 'cover', 
                                            borderTopLeftRadius: '4px', 
                                            borderTopRightRadius: '4px' 
                                        }} 
                                    />
                                </CardMedia>
                            )}
                            <CardHeader>
                                <h3 style={{ margin: 0 }}>{plugin.name}</h3>
                            </CardHeader>
                            <CardBody>
                                <p style={{ marginBottom: '15px' }}>{plugin.shortdescription}</p>
                                <a href={plugin.url} target="_blank" rel="noopener noreferrer">
                                    <Button isPrimary>View Plugin</Button>
                                </a>
                            </CardBody>
                        </Card>
                    ))}
                </div>
            )}
        </PanelBody>
    );
};

export default MorePluginTab;
